import { Components } from "@mui/material/styles";

declare module "@mui/material/Alert" {
  interface AlertPropsColorOverrides {
    muted: true;
  }
}

const alert: {
  MuiAlert: Components["MuiAlert"];
} = {
  MuiAlert: {
    styleOverrides: {
      root: ({ ownerState }) => ({
        ...(ownerState.color === "muted" && {
          backgroundColor: "#b0b0b0",
          color: "#333333",
        }),
      }),
    },
  },
};

export default alert;
